import { t } from '@/i18n/I18n';

// ── Condition types ──
export enum ConditionType {
  ENEMY_DETECTED = 'enemyDetected',
  ENEMY_CLOSE = 'enemyClose',
  NO_ENEMY_DETECTED = 'noEnemyDetected',
  ENEMY_IN_ZONE = 'enemyInZone',
  LOW_ENERGY = 'lowEnergy',
  ALLY_LOW_ENERGY = 'allyLowEnergy',
  ALLY_NEARBY_DAMAGED = 'allyNearbyDamaged',
  BASE_DAMAGED = 'baseDamaged',
  RESOURCE_DETECTED = 'resourceDetected',
  ALWAYS = 'always',
}

// ── Action types ──
export enum ActionType {
  SHOOT = 'shoot',
  ADVANCE = 'advance',
  RETREAT = 'retreat',
  HOLD_POSITION = 'holdPosition',
  PATROL = 'patrol',
  PROTECT_ALLY = 'protectAlly',
  FALL_BACK = 'fallBack',
  EXPLODE = 'explode',
  REPAIR_ALLY = 'repairAlly',
  RECHARGE_ALLY = 'rechargeAlly',
  CHASE = 'chase',
  SEEK_RECHARGER = 'seekRecharger',
  REPAIR_BASE = 'repairBase',
  ATTACK_BASE = 'attackBase',
  PURSUE = 'pursue',
  HARVEST = 'harvest',
}

// ── Target modifier ──
export enum TargetModifier {
  CLOSEST = 'closest',
  MOST_ADVANCED = 'mostAdvanced',
}

// ── A single behavior rule ──
export interface BehaviorRule {
  priority: number;          // lower = higher priority
  condition: ConditionType;
  action: ActionType;
  targetModifier?: TargetModifier;
  distanceThreshold?: number; // optional distance param
}

// ── Human-readable labels for UI (i18n) ──

/** Return the localized label for a condition type. */
export function getConditionLabel(c: ConditionType): string {
  return t(`behavior.condition.${c}`);
}

/** Return the localized label for an action type. */
export function getActionLabel(a: ActionType): string {
  return t(`behavior.action.${a}`);
}

/** Return the localized label for a target modifier. */
export function getTargetModifierLabel(m: TargetModifier): string {
  return t(`behavior.target.${m}`);
}
